import React from "react";
import contactUsBanner from "../../assets/contact-us-banner.png";

const ContactUsBanner = () => {
  return (
    <div
      className="bg-cover bg-center my-8 mx-6 rounded-3xl h-[210px] sm:h-[300px] md:h-[70vh] lg:h-[500px] px-4"
      style={{ backgroundImage: `url(${contactUsBanner})` }}
    >
      {/* Container for the text elements */}
        {/* Top Section: Heading, Subheading and Sign Up Button */}
      <div className="h-full flex flex-col justify-center ">
        <div>
          <h1 className="font-bold text-white text-center text-3xl sm:text-4xl md:text-5xl">Contact Us</h1>
          <div className="border-b-4 border-white-500 w-36 sm:48 md:w-64 mx-auto mt-2"></div> 
      </div>
        <p className="text-white font-bold mx-auto mt-5 text-xs sm:text-2xl text-center">Please call, or write to us and we'd be happy to clarify any
          <br className="hidden sm:block"/> 
          additional details you'd like.
          </p> 
      </div>
    </div>
  );
};

export default ContactUsBanner;

